const CREDENTIALS = {
  appId: process.env.MIX_CONNECTYCUBE_APP_ID,
  authKey: process.env.MIX_CONNECTYCUBE_AUTH_KEY,
  authSecret: process.env.MIX_CONNECTYCUBE_AUTH_SECRET,
};

const CONFIG = {
  debug: { mode: 0 }, // enable DEBUG mode (mode 0 is logs off, mode 1 -> console.log())
  on: {
    sessionExpired: (_handleResponse, retry) => {
      ConnectyCube.createSession((_error, session) => {
        retry(session);
      });
    },
  },
};

try {
  ConnectyCube.init(CREDENTIALS, CONFIG);
} catch (error) {
  // Ignored
}
